import { apiRoutes } from '@features/campaigns/shared/consts/apiRoutes.ts';
import { ListCreatableMediaTypesResponse } from '@features/campaigns/shared/types/creatableMediaTypes.ts';
import { apiClient } from '@shared/api/ApiClient.ts';

export async function listCreatableMediaTypes(): Promise<ListCreatableMediaTypesResponse | null> {
  return await apiClient.get<ListCreatableMediaTypesResponse>(apiRoutes.getCreatableMediaTypes());
}
